<template>
  <div id="loading" :class = "{'hidden': !this.isLoading, 'show': this.isLoading}">
    <h1>⏳ Loading...</h1>
  </div>
  <div id="hello" :class = "{'hidden': this.isLoading, 'show': !this.isLoading}">
    <div class="header_container">
      <h1 class="header">다운로드</h1>
    </div>

    <div>
      <div v-for="item in data.ver.data" :key="item.hash" class="main_container">
        <div class = "logo_container">
          <img :src= "getSrcPath(item.name)"
          @error="handleImageError" alt="" class="program_logo" />
          <!--<img :src= "require('/home/node/app/medi-download/src/assets/'+item.NAME+'.png')"
          @error="handleImageError" alt="" class="logo" /> -->
        </div>
        <div class = "main">
          <div class = "name_container">
            <h2 class = "name">{{ item.name }}</h2>
            <div class="badge_container">
              <span v-if="checkApprovedLength(item.name) == 0" class = "mark for_research">연구용</span>
              <img v-for="ins in data.approved[item.name]" :key="ins" :src="getSrcPath(ins)" alt="">
            </div>
          </div>
          <h3>New Feature</h3>
          <div class="patchnote-container">{{ item.note }}</div>
          <hr/>
          <h3>File Information</h3>
          <div class="patchnote-container">
            <div>ℹ️{{ item.version }}</div>
            <div class="hash">🔐{{item.hash}}</div>
            <div>🕒{{item.upload_date.split('T')[0]}}</div>
          </div>
          <div v-if="item.name != 'VINT DEV'" class="button_container">
            <a v-bind:href="'/api/file/download?app='+item.name+'&ver='+item.version+'&type=zip'" class='download_button button'>.ZIP DOWNLOAD</a>
            <a v-bind:href="'/api/file/download?app='+item.name+'&ver='+item.version+'&type=exe'" class='download_button button'>.EXE DOWNLOAD</a>
          </div>
          <div v-else></div>
        </div>
      </div>
    </div>
    <!--<p>{{ data.ver.data }}</p>-->
  </div>
</template>

<script nonce = "HelloWorld">
  import '../assets/css/HelloWorld.css';
  import '../assets/css/defaultPage.css';
  import axios from 'axios';
  export default {
    name: 'HelloWorld',
    props: {msg: String},
    data() {
      return {
        isLoading: true,
        data:{
          ver: '⏳ Loading...',
          approved: {'NeuFlow': ['MFDS', 'FDA'], 'VINT FLOW': [], 'VINT': ['MFDS'], 'FloCal': ['MFDS']},
          // isLogin: false
        }
      }
    },
    methods: {
    checkApprovedLength(item){
      if (this.data.approved[item] == undefined){
        return 0;
      } else {
        return this.data.approved[item].length;
      }
    },
    getSrcPath(key){
      console.log('../assets/img/'+key+'.png');
      try {
        return require('../assets/img/'+key+'.png');
      } catch(error) {
        return require('../assets/img/logo.png');
      }
    },
    handleImageError(event){
      event.target.src = require('../assets/img/logo.png');
    },
    fetchData() {
      axios
        .get("/api/file/versions")
        .then(res => {
          this.data.ver = res;
        })
        .catch(err => {
          console.log('error', err.code);
          if (err.code == 'ERR_BAD_RESPONSE'){
            console.log('server off.');
            this.$router.push('/maintenance');
          }
        });
      },
    },
    async created() {
      this.isLoading = true;
      await this.fetchData();
      this.isLoading = false;
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<!-- <style scoped>
/* @import "../assets/defaultPage.css"; */

</style> -->